import React from 'react';
import mixpanel from 'mixpanel-browser';
import { messages } from '../../../constants/Forms/contact';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const ContactSubmitted = () => {
  const navigate = useNavigate();
  const submit = () => {
    navigate('/');
    mixpanel.track('Contact Us Page Submitted', {
      path: '/contact',
    });
  };
  return (
    <>
      <div className="contactFormSubmission">
        <img
          src="https://cdn-icons-png.freepik.com/512/7390/7390035.png"
          className="submittedImg"
        />
        <h1 className="formSubmittedh5">{messages.thankYou}</h1>
        <div className="formSubmittedp">
          <p>{messages.thankYouMessage}</p>
          <p>{messages.thankYouMessage2}</p>
        </div>
        <Button className="goBackBtn" type="submit" onClick={submit}>
          {messages.goBack}
        </Button>
      </div>
    </>
  );
};
